import axios from "axios";

const initialState = () => {
  return {
    validationLoading: false,
    validatedAdresses: {},
    possibleStreets: [],
    possibleHouses: [],

    show_valid_arrow: false,
    checkAddresButtonDisable: true
  }
}

export default {
  state: initialState(),
  getters: {
    getValidatedAdresses: (state) => state?.validatedAdresses,
    getValidatedAdressesControls: (state) =>
      state?.validatedAdresses?.data?.control_attributes,
    getPossibleStreets: (state) => state?.possibleStreets,
    getPossibleHouses: (state) => state?.possibleHouses,
    getValidationLoading: (state) => state.validationLoading,
    getShowValidArrow: (state) => state.show_valid_arrow,
    getCheckAddresButtonDisable: (state) => state.checkAddresButtonDisable,
  },
  mutations: {
    MUTATE_VALIDATED_ADRESSES(state, payload) {
      state.validatedAdresses = payload;
    },
    MUTATE_SHOW_VALID_ARROW(state, payload) {
      state.show_valid_arrow = payload;
    },
    MUTATE_CHECK_ADDRES_DISABLE(state, payload) {
      state.checkAddresButtonDisable = payload;
    },
    MUTATE_POSSIBLE_ADDRESSES(state, payload) {
      state.possibleStreets = payload.streetArr;
      state.possibleHouses = payload.houseArr;
    },
    MUTATE_VALIDATED_LOADING(state, payload) {
      state.validationLoading = payload;
    },
    RESET_ADDRES_CHECKING_STATE(state) {
      Object.assign(state, initialState())
    },
  },
  actions: {
    async validateAddress({ commit, dispatch, rootState }, data) {
      commit("MUTATE_VALIDATED_LOADING", true);
      commit("MUTATE_POSSIBLE_ADDRESSES", {
        streetArr: [],
        houseArr: []
      });
      const addressForm = rootState.order.forms.requestForm.address;
      const payload = {
        // company_name: "",
        line1:
          addressForm.house && addressForm.street
            ? `${addressForm.house} ${addressForm.street}`
            : "",
        // line2: "",
        // line3: "",
        city: addressForm.city ? addressForm.city : "",
        state_province: addressForm.area ? addressForm.area : "",
        postal_code: addressForm.zip ? addressForm.zip : "",
        country_code: "US",
      };
      try {
        const response = await axios.post("order/validate-address", payload);
        const { control_attributes, ...rest } = response.data.data;

        const responseTransform = {
          status: response.data.status,
          data: {
            ...rest,
            control_attributes: {
              area: control_attributes.state_province,
              house: parseAddressString(control_attributes.line1).house,
              street: parseAddressString(control_attributes.line1).street,
              city: control_attributes.city,
              zip: control_attributes.postal_code,
            },
          },
        };
        commit("MUTATE_VALIDATED_ADRESSES", responseTransform);
        if (
          !responseTransform.data.address_exists &&
          addressForm.house &&
          addressForm.zip
        ) {
          dispatch("getPossibleAddresses");
        } else {
          commit("MUTATE_VALIDATED_LOADING", false);
        }
      } catch (e) {
        commit("MUTATE_VALIDATED_LOADING", false);
        // console.log(e);
        throw e;
      }
    },
    async getPossibleAddresses({ commit, rootState }) {
      const addressForm = rootState.order.forms.requestForm.address;
      const zip = addressForm.zip;
      const house = addressForm.house;
      const street = addressForm.street;

      let path = `order/possible-addresses?zip5=${zip}&primary=${house}`;
      if (street) {
        path = `${path}&street_name=${street}`;
      }

      try {
        const response = await axios.get(path);
        if(response?.data?.data?.response) {
          const arr = response?.data?.data?.response.map((i) => {
            return {
              house: parseAddressString(i).house,
              street: parseAddressString(i).street,
            };
          });
          const streetArr = arr.map(i => i.street);
          const houseArr = arr.map(i => i.house);
          const data = {
            streetArr,
            houseArr
          }
          // console.log('MUTATE:', data);
  
          commit("MUTATE_POSSIBLE_ADDRESSES", data);
        }
      } catch (e) {
        // console.log(e);
        throw e;
      } finally {
        commit("MUTATE_VALIDATED_LOADING", false);
      }
    },
  },
};

function parseAddressString(string)  {
  return {
    house: string.substr(0, string.indexOf(" ")),
    street: string.substr(string.indexOf(" ") + 1),
  }
}